<template>
  <v-container>
    <v-layout row>
      <v-flex class="xs12 sm12">
        <v-btn fab absolute left to="dashboard" class="ml-3 pf-btn-fab">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-70">
      <v-flex xs12 sm6 md4 pr-3>
        <v-autocomplete
          label="Account"
          :items="[this.Account.human[0].name]"
          v-model="accountSelected"
          disabled
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-daterange
          ref="dateRange" 
          v-model="dateRange"
          :presets="presets" 
          display-format="MM/dd/yyyy"
          :max="new Date().toISOString().substr(0,10)" 
          :input-props="inputProps"
          :show-reset="false"
          @menu-closed="getCountItems"
          class="dateRange pr-3">
        </v-daterange>
      </v-flex>
      <v-flex xs12 sm6 md2 pr-3>
        <v-autocomplete
          label="Location"
          :items="locationItems"
          v-model="locationSelected"
          @change="changeAtLocationAction()"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md2>
        <v-autocomplete
          label="Action Type"
          :items="actionTypeItems"
          v-model="actionTypeSelected"
          @change="changeAtLocationAction()"
        ></v-autocomplete>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card min-height="500">
          <v-toolbar color="transparent" flat dense card>
            <v-toolbar-title>
              <h5 class="body-1">
                <b>Account: </b>{{ this.Account.human[0].name }}  
                <span class="pl-3 pr-2"><b>From: </b>{{ formatDateFilter(dateRange.start) }} </span>
                <b>To: </b>{{ formatDateFilter(dateRange.end) }}
                <span class="pl-3"><b> Location: </b>{{ locationSelected}}</span>
              </h5>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="pt-0">
            <v-layout row wrap>
              <v-flex xs12 pr-5 v-if="totalRecords > 0">
                <e-chart
                  ref="chart"
                  :path-option="[
                    ['dataset.source', dataset.Activity],
                    ['color', [color.lightBlue.base, color.indigo.base, color.pink.base, color.teal.base, color.deepPurple.base, color.green.base, color.cyan.base, color.amber.base]],
                    ['legend.orient', 'vertical'],
                    ['legend.y', 'center'],
                    ['legend.x', 'right'],
                    ['xAxis.show', false],
                    ['yAxis.show', false],          
                    ['series[0].type', 'pie'],         
                  ]"
                  height="300px"
                  width="100%"
                >
                </e-chart>
              </v-flex>
               <v-flex v-else xs12 pr-5 class="cardClass mt-5">
                <div class="font-weight-bold cardText justify-center">No data available</div>
              </v-flex>
              <v-flex>
                  <div class="text-xs-right">
                      <v-btn
                      color="pf-btn pf-bg-teal"
                      dark
                      small
                      :disabled="this.totalRecords > 0 ? false : true"
                      @click="initialize()"
                    >
                      <span> Get Activity </span>
                    </v-btn>
                </div>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  v-if="Activity.length"
                  :headers="headers"
                  :items="Activity.filter(activity => (activity.action === this.actionTypeSelected || this.actionTypeSelected === 'All') && (activity.reference_url === this.locationSelected || this.locationSelected === 'All'))"
                  :loading="loading"
                  :pagination.sync="pagination" 
                >
                  <template v-slot:items="props">
                    <td>{{ formatDate(props.item.createdAt, 'MM-DD-YYYY')}}</td>
                    <td>{{ props.item.resource }}</td>
                    <td>{{ props.item.action }}</td>
                    <td>
                      <v-tooltip top v-if="props.item.reference_url">
                        <template v-slot:activator="{ on }">
                          <span v-on="on">{{props.item.reference_url.substr(0, 60) + (props.item.reference_url.length > 60 ? '...' : '')}}</span>
                        </template>
                        <span>
                          <v-icon small dark>open_in_new</v-icon> Go To Location:<br>
                          {{ props.item.reference_url }}
                        </span>
                      </v-tooltip>
                    </td>
                    <!-- <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }" v-if="props.item.consumer">
                          <span v-on="on">{{ props.item.consumer.ip }}</span>
                        </template>
                        <span> 
                          {{ props.item.consumer && props.item.consumer.city ? props.item.consumer.city + ' /' : ''}}
                          {{ props.item.consumer && props.item.consumer.country }}
                        </span>
                      </v-tooltip>
                    </td> -->
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>       
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* global session router store config */
import swal from 'sweetalert2';
import { getCollection, formatDate, request } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import moment from 'moment';

import EChart from '@/components/chart/echart';
import Material from 'vuetify/es5/util/colors';
import { VDaterange } from 'vuetify-daterange-picker';
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css';

// This lists the FAQ items to the agency and family
export default {
  name: 'Activity',
  components: {
    EChart,
    VDaterange
  },
  data: () => ({
    entity: 'BadgeActivity',
    pagination: {
      sortBy: 'createdAt', // The field that you're sorting by
      descending: true,
      rowsPerPage: config.dom.rowsPerPage
    },
    accountSelected: '',
    locationSelected: 'All',
    locationItems: ['All'],
    actionTypeSelected: 'All',
    actionTypeItems: ['All'],
    dateRange: { 
      start: null, 
      end: null 
    },
    presets: [
      {
        label: 'Last 2 days',
        range: [
          moment().add(-1, 'days').format('YYYY-MM-DD'),
          moment().endOf('day').format('YYYY-MM-DD'),
        ],
      },
      {
        label: 'Yesterday',
        range: [
          moment().add(-1, 'days').format('YYYY-MM-DD'),
          moment().add(-1, 'days').endOf('day').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'This Week',
        range: [
          moment().startOf('week').format('YYYY-MM-DD'),
          moment().endOf('week').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'Last 7 days',
        range: [
          moment().add(-7, 'days').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'Last 15 days',
        range: [
          moment().add(-15, 'days').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'This Month',
        range: [
          moment().startOf('month').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'Last Month',
        range: [
          moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
          moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'Last 3 Month',
        range: [
          moment().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),
          moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'Last 1 Year',
        range: [
          moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'),
          moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD')
        ]
      },
    ],
    inputProps: {
      'prepend-icon': 'event',
      'label': 'Date Range'
    },
    dataset: {
      Activity: [
        {
          value: 0,
          name: 'Profile'
        },
        {
          value: 0,
          name: 'Photo'
        },
        {
          value: 0,
          name: 'Video'
        },
        {
          value: 0,
          name: 'Vitals'
        },
        {
          value: 0,
          name: 'Journal'
        },
        {
          value: 0,
          name: 'Letter'
        },
        {
          value: 0,
          name: 'Flipbook'
        },
        {
          value: 0,
          name: 'PdfProfile'
        },
      ],
      defaultActivity: [
        {
          value: 0,
          name: 'Profile'
        },
        {
          value: 0,
          name: 'Photo'
        },
        {
          value: 0,
          name: 'Video'
        },
        {
          value: 0,
          name: 'Vitals'
        },
        {
          value: 0,
          name: 'Journal'
        },
        {
          value: 0,
          name: 'Letter'
        },
        {
          value: 0,
          name: 'Flipbook'
        },
        {
          value: 0,
          name: 'PdfProfile'
        },
      ],
    },
    color: Material,
    headers: [
      {
        text: 'Date',
        align: 'left',
        value: 'createdAt'
      },
      { text: 'Resource', value: 'resource' },
      { text: 'Type', value: 'action' },
      { text: 'Location', value: 'reference_url' },
      // { text: 'IP Address', value: 'consumer.ip' }
    ],
    loading: false,
    Activity: [],
    aggregateData: [],
    totalRecords: 0,
    chart: false,
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Account']),

  },
  watch: {
    //
  },
  created () {
    this.accountSelected = this.Account.human[0].name;
  },
  methods: {
    formatDateFilter (date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    changeAtLocationAction () {
      this.totalRecords = 0;
      this.dataset.Activity.forEach((element, i) => {
        element.value = 0;
        element.name = this.dataset.defaultActivity[i].name;
      });
      if (this.aggregateData.filteredData.length > 0) {
        this.aggregateData.filteredData.forEach(element => {
          if ((element.location === this.locationSelected || this.locationSelected === 'All') && (element.action === this.actionTypeSelected || this.actionTypeSelected === 'All')) {
            let index = this.dataset.Activity.findIndex(act => act.name === element.resource);
            this.dataset.Activity[index].value = this.dataset.Activity[index].value + element.count;
          }
        });
        this.dataset.Activity.forEach(element => {
          this.totalRecords = this.totalRecords + element.value;
          element.name = `${element.name} (${element.value})`;
        });
      }
      this.$refs.chart.init();
    },
    async getCountItems () {
      if (this.dateRange.start === null && this.dateRange.end === null) {
        swal.fire({
          title: 'No Date Range found',
          text: 'Please select valid Date Range',
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK'
        });
        return;
      }
      this.actionTypeItems = ['All'];
      this.locationItems = ['All'];
      this.locationSelected = 'All';
      this.actionTypeSelected = 'All';
      this.Activity = [];
      this.totalRecords = 0;
      this.dataset.Activity.forEach((element, i) => {
        element.value = 0;
        element.name = this.dataset.defaultActivity[i].name;
      });
      let payload = {
        account: this.Account.id,
        role: 'parent'
      };
      if (this.dateRange.start && this.dateRange.end) {
        payload.startDate = this.dateRange.start;
        payload.endDate = this.dateRange.end;
      }
      let { error, data } = await request('BadgeActivity/count', 'GET', payload);
      if (error) {
        console.log(error);
      } else {
        this.chart = true;
        this.aggregateData = data;
        if (this.aggregateData.filteredData.length > 0) {
          this.aggregateData.filteredData.forEach(element => {
            if ((element.location === this.locationSelected || this.locationSelected === 'All') && (element.action === this.actionTypeSelected || this.actionTypeSelected === 'All')) {
              let index = this.dataset.Activity.findIndex(act => act.name === element.resource);
              this.dataset.Activity[index].value = this.dataset.Activity[index].value + element.count;
            }
            this.actionTypeItems.push(element.action);
            this.locationItems.push(element.location);
          });
          this.dataset.Activity.forEach(element => {
            this.totalRecords = this.totalRecords + element.value;
            element.name = `${element.name} (${element.value})`;
          });
        }
        this.$nextTick(() => {
          if (this.totalRecords !== 0) {
            this.$refs.chart.init();
          }
        });
        this.actionTypeItems = [...new Set(this.actionTypeItems)];
        this.locationItems = [...new Set(this.locationItems)];
      }
    },
    // @vuese
    // Used to fetch the Activity list if not already exists
    async initialize () {
      this.loading = true;
      this.Activity = [];
      let sort = { 'updatedAt': -1 };
      let where = { $and: [{ account: this.Account.id }] };
      where.$and.push({ reference_url: { $ne: '' }}, { reference_url: { $ne: null }}, { reference_url: { $ne: 'localhost' }}, { reference_url: { $ne: 'null' }});
      // if (this.actionTypeSelected !== 'All') where.$and.push({ action: this.actionTypeSelected });
      // if (this.locationSelected !== 'All') where.$and.push({ reference_url: this.locationSelected });
      if (this.dateRange.start !== null) where.$and.push({ createdAt: { $gte: new Date(this.dateRange.start).toISOString(), $lte: moment(this.dateRange.end).endOf('day').toISOString() }});
      let { error, data } = await getCollection(this.entity, true, 0, '', where, null, null, sort);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.Activity = data;
        }
        this.loading = false;
      }
    },
    formatDate (date, format = 'MM/DD/YYYY') {
      return formatDate(date, format);
    }
  }
}; 

</script>

<style scoped>
.dateRange >>> .v-menu {
  width: 100% !important;
}

.v-date-range__content a.v-list__tile.v-list__tile--link.theme--light {
  font-size: 14px !important;
  height: 32px !important;
  background-color: #333 !important;
}

.cardClass {
  align-items: center;
  display: flex;
  justify-content: center;
}

.cardText {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/Activity/list.vue